import React from 'react'

import {
  Box,
  Color,
  Display,
  DisplayPosition,
  FontWeight,
  Link,
  LinkVariant,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

type LinkProps = {
  href: string
  text: string
}

const StyledHeaderLink = withCitrusTheme(Box, (theme) => ({
  display: Display.Flex,
  color: Color.White,
  fontWeight: FontWeight.SemiBold,
  fontSize: '14px',
  '&:hover': {
    textDecorationLine: 'underline',
    textDecorationColor: theme.color(Color.White),
    textDecorationThickness: '2px',
    textUnderlineOffset: '6px',
  },
  '& a:focus': {
    outline: 'none',
    border: `1px solid ${theme.color(Color.White)}`,
    borderRadius: '3px',
    color: Color.White,
    textDecorationLine: 'none',
  },
}))

const StyledLink = ({ href, text }: LinkProps) => (
  <StyledHeaderLink>
    <Link
      data-testid={`header-link-${text.replace(/\s+/g, '-')}`}
      href={href}
      variant={LinkVariant.None}
      style={{ borderRadius: '3px', padding: '3px' }}
    >
      {text.toUpperCase()}
    </Link>
  </StyledHeaderLink>
)

export const HeaderLink = ({ href, text }: LinkProps) => (
  <Box display={Display.InlineBlock} position={DisplayPosition.Relative} paddingRight={6}>
    <StyledLink href={href} text={text} />
  </Box>
)
